function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#5e5e5d}\n        "));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  className: "cls-2",
  d: "M15.5 31.82v-.3a1.42 1.42 0 0 1 .17-.72 1.24 1.24 0 0 1 .49-.5 1.56 1.56 0 0 1 .74-.17 1.35 1.35 0 0 1 1 .39 1.4 1.4 0 0 1 .38 1v.3a1.53 1.53 0 0 1-.17.72 1.26 1.26 0 0 1-.48.49 1.47 1.47 0 0 1-.74.18 1.36 1.36 0 0 1-1-.39 1.34 1.34 0 0 1-.39-1zm.7-.3v.3a.89.89 0 0 0 .18.58.61.61 0 0 0 .53.23.57.57 0 0 0 .51-.23 1 1 0 0 0 .17-.58v-.3a1 1 0 0 0-.17-.58.7.7 0 0 0-1 0 .93.93 0 0 0-.22.58z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_165",
  "data-name": "Path 165",
  className: "cls-2",
  d: "M24.5 32.12h-1.25a1.21 1.21 0 0 0-.14-.43 1.175 1.175 0 0 0-.65-.53 1.7 1.7 0 0 0-.46-.07 1.36 1.36 0 0 0-.79.23 1.39 1.39 0 0 0-.53.65 2.6 2.6 0 0 0-.18 1 2.5 2.5 0 0 0 .19 1 1.4 1.4 0 0 0 .52.64 1.35 1.35 0 0 0 .78.22 1.39 1.39 0 0 0 .46-.07 1.23 1.23 0 0 0 .38-.19 1.14 1.14 0 0 0 .27-.31 1.11 1.11 0 0 0 .15-.42h1.25a2.1 2.1 0 0 1-.24.77 2.53 2.53 0 0 1-.51.67 2.58 2.58 0 0 1-.77.46A2.93 2.93 0 0 1 22 36a2.82 2.82 0 0 1-1.4-.35 2.54 2.54 0 0 1-1-1 3.49 3.49 0 0 1-.35-1.65 3.41 3.41 0 0 1 .36-1.63 2.58 2.58 0 0 1 1-1A2.79 2.79 0 0 1 22 30a3.14 3.14 0 0 1 .94.14 2.49 2.49 0 0 1 .77.42 2.07 2.07 0 0 1 .55.66 2.62 2.62 0 0 1 .24.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "400");

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_166",
  "data-name": "Path 166",
  className: "cls-2",
  d: "M17.57 7.26V6.09l4.66-2v1.29L19 6.66v.03L22.23 8v1.31z"
});

function SvgIcnLess400C({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-less400c",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-base",
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), _ref2, _ref3, /*#__PURE__*/React.createElement("text", {
    id: "_400",
    "data-name": 400,
    transform: "translate(3.57 23.91)",
    style: {
      fontSize: 16,
      fontFamily: "Inter",
      fontWeight: 700,
      fill: "#5e5e5d"
    }
  }, _ref4), _ref5));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLess400C);
export default __webpack_public_path__ + "static/media/icn-less400c.232b654d9cadb66438ef23af7751f280.svg";
export { ForwardRef as ReactComponent };